import React, { useEffect, useState } from 'react'
import { listarDocumentosDerivacion } from '../../utils/Datos';
import {BotonDocumento} from '../Otros/BotonDocumento';

export const DocumentosDerivacion = (
    {id_answer_derivation=null}
) => {

    const [listadoDocumentos, setlistadoDocumentos] = useState([]);
    const [existeDoc, setexisteDoc] = useState(false)
    useEffect(() => {
            if (id_answer_derivation!=null) {
                listarDocumentosDerivacion(id_answer_derivation).then((respuesta)=>{
                    if (respuesta.status) {
                        setlistadoDocumentos(respuesta.datos);
                        console.log("THE-DOCS",respuesta.datos)
                        respuesta.datos.map((documento,index)=>{
                            if (!documento.is_resolution) {
                                setexisteDoc(true);
                            }

                        })
                    }else{
                        console.log("Error en los documentos")
                    }

                })
            }

        }

    , [id_answer_derivation])


    return (
            listadoDocumentos.length>0 &&
            <>

                <label className="form-label form-control-solid">Documentos</label>
                <div className='row'>
                    {
                        listadoDocumentos.map((documento,index)=>{

                                //setexisteDoc(true);
                                return <div className='col-md-auto'>
                                <BotonDocumento
                                key={`doc_${index}`}
                                documento={documento} ></BotonDocumento></div>


                        })
                    }
                </div>
            </>

    )
}
